import React from 'react'
import { Grid } from '@material-ui/core'
import { formatAddressInlineAsText, formatDate, formatCurrency } from '../../../../../common/helpers'
import LocationsAffectedTable from '../../../../../common/components/locationsAffected/notificationsModal/table'
import { paperStyles } from './styles'

const MinWageNotificationDetail = ({ notification, includeTips }) => {
  if (notification && notification.locationsData) {
    notification.locationsData.map((location) => Object.assign(location, { address: formatAddressInlineAsText(location) }))
  }
  return (
    // eslint-disable-next-line react/jsx-filename-extension
    <div style={paperStyles}>
      <Grid className="text" container spacing={24}>
        <Grid item xs={6} style={{ textAlign: 'left' }} data-testid="mw-notification-details-date-of-change">
          {`Date Of Change: ${formatDate(notification.notificationDate)}`}
        </Grid>
        <Grid item xs={6}>&nbsp;</Grid>
        {notification.notificationNewWage && notification.notificationNewWage.indexed
          ? <Grid item xs={3} data-testid="mw-notification-details-new-wage">New Wage: Indexed</Grid>
          : (
            <Grid item xs={3} data-testid="mw-notification-details-new-wage">
              {notification.notificationNewWage
                ? (`New Wage: ${formatCurrency(notification.notificationNewWage.amount)}`) : 'No Change'}
            </Grid>
          )}
        <Grid item xs={3} data-testid="mw-notification-details-min-wage">
          {notification.notificationPrevailingWage
            ? (`Min. Wage: ${formatCurrency(notification.notificationPrevailingWage.amount)}`) : 'No Change'}
        </Grid>
        {includeTips ? (
          // eslint-disable-next-line react/jsx-fragments
          <React.Fragment>
            {notification.notificationNewTipWage && notification.notificationNewTipWage.indexed
              ? <Grid item xs={3} data-testid="mw-notification-details-new-wage">New Tip. Wage: Indexed</Grid>
              : (
                <Grid item xs={3} data-testid="mw-notification-details-new-tip-wage">
                  {notification.hasMultipleTippedWages ? 'See location details' : notification.notificationNewTipWage
                    ? (`New Tip. Wage: ${formatCurrency(notification.notificationNewTipWage.amount)}`) : 'No Change'}
                </Grid>
              )}
            <Grid item xs={3} data-testid="mw-notification-details-tip-wage">
              {notification.hasMultipleTippedWages ? 'See location details' : notification.notificationPrevailingTipWage
                ? (`Tip. Wage: ${formatCurrency(notification.notificationPrevailingTipWage.amount)}`) : 'No Change'}
            </Grid>
          </React.Fragment>
        ) : null}
      </Grid>
      <LocationsAffectedTable isMinWage notificationItem={notification} />
    </div>
  )
}

export default MinWageNotificationDetail
